<template>
    <section class="component" style="position: relative">
        <section class="component__header">
            <span class="component__header__title">
                {{ $t('com.file.session-point-list.voting-settings') }}
            </span>
        </section>
        <section class="component__body settings">
            <section class="settings__item">
                <section class="column-item in-row">
                    <InputSwitchWithLabel id="adminVoteForUser_id"
                                          v-model="internalVotingSettings.adminVoteForUser" @change="$emit('change', internalVotingSettings)">
                        {{ $t('com.file.voting-settings.admin-vote-for-user') }}
                    </InputSwitchWithLabel>
                </section>

                <section class="column-item in-row">
                    <InputSwitchWithLabel id="autoEndVotingAfterAllVoted_id"
                                          v-model="internalVotingSettings.autoEndVotingAfterAllVoted"
                                          @change="$emit('change', internalVotingSettings)">
                        {{ $t('com.file.voting-settings.end-voting-automatic') }}
                    </InputSwitchWithLabel>
                </section>

                <section class="column-item in-row">
                    <InputSwitchWithLabel id="autoGoToNextVotingAfterSave_id"
                                          v-model="internalVotingSettings.autoGoToNextVotingAfterSave"
                                          @change="$emit('change', internalVotingSettings)">
                        {{ $t('com.file.voting-settings.next-voting-automatic') }}
                    </InputSwitchWithLabel>
                </section>

                <section class="column-item in-row">
                    <InputSwitchWithLabel id="rememberVotingMode_id"
                                          v-model="internalVotingSettings.rememberVotingMode"
                                          @change="$emit('change', internalVotingSettings)">
                        {{ $t('com.file.voting-settings.remember-voting-mode') }}
                    </InputSwitchWithLabel>
                </section>

                <section class="column-item in-row">
                    <InputSwitchWithLabel id="autoStartNextVoting_id"
                                          v-model="internalVotingSettings.autoStartNextVoting"
                                          @change="$emit('change', internalVotingSettings)">
                        {{ $t('com.file.voting-settings.start-next-voting-automatic') }}
                    </InputSwitchWithLabel>
                </section>

                <section class="column-item in-row" style="padding: 0 10px;">
                    <section class="esesja-modal__row">
                        <select class="edit-point-form__input"
                                v-model="internalVotingSettings.autoStartNextVotingTime"
                                @change="$emit('change', internalVotingSettings)"
                                :disabled="internalVotingSettings.autoStartNextVoting == false">
                            <option v-for="s in automaticNextVotingTime" :value="s.id" :key="s.id">
                                {{ s.type }}
                            </option>
                        </select>
                    </section>
                    <label class="esesja-modal__wraper__body__label" for="autoStartNextVoting_id">
                        {{ $t('com.file.voting-settings.start-next-voting-time-automatic') }}
                    </label>
                </section>
                <section v-if="showAllowedIp" class="column-item in-row" style="padding: 0 10px; justify-content: space-between;">
                    <section class="d-flex flex-column">
                        <section class="esesja-modal__row">
                            <SearchLabelComponent :label="$t('com.file.voting-settings.ip-can-vote')" />
                            <InputComponent v-model="internalVotingAllowedIp" :isError="!isValidIp"
                                            :errorTooltip="allowedIpTooltip" />
                        </section>
                    </section>
                    <ButtonOutline @click="$emit('saveAllowedVotingIp', internalVotingAllowedIp)" color="light" :disable="!isValidIp">
                        {{ $t('com.global.save') }}
                    </ButtonOutline>
                </section>
            </section>
        </section>
        <SmallLoader v-if="isLoading" />
    </section>
</template>
<script charset="utf-8">
//import settingsService from "@/services/settings.service";
import SmallLoader from "@/components/BasicControls/SmallLoader.vue";
import { validateIp } from "@/helpers/utils";
//import alertsHelper from "@/helpers/alerts.helper";

import InputComponent from "@/components/BasicControls/InputComponent.vue";
import SearchLabelComponent from "@/components/BasicControls/SearchLabelComponent.vue";
import ButtonOutline from "@/components/BasicControls/Buttons/ButtonOutline.vue";
import InputSwitchWithLabel from "@/components/BasicControls/InputSwitchWithLabel.vue";
export default {
    name: "VotingSettings",
    emits: ["change", "saveAllowedVotingIp"],
    components: {
        SmallLoader,
        InputComponent,
        SearchLabelComponent,
        ButtonOutline,
        InputSwitchWithLabel
    },
    props: {
        votingSettings:{
            type: Object,
            required: true,
            default: () => ({
                
            })
        },
        votingAllowedIp:{
            type: String,
            required: true,
        },
        showAllowedIp: {
            type: Boolean,
            required: true,
            default: true
        },
        isLoading: {
            type: Boolean,
            required: true,
        }
    },
    computed: {
        allowedIpTooltip() {
            if (!this.isValidIp) {
                return this.$t('com.file.voting-settings.ip-error-info');
            }
            return "";
        }
    },
    data() {
        return {
            //isLoading: false,
            automaticNextVotingTime: [
                { id: 3, type: this.$t('com.file.voting-settings.3-sec') },
                { id: 4, type: this.$t('com.file.voting-settings.4-sec') },
                { id: 5, type: this.$t('com.file.voting-settings.5-sec') },
                { id: 6, type: this.$t('com.file.voting-settings.6-sec') },
                { id: 7, type: this.$t('com.file.voting-settings.7-sec') },
                { id: 8, type: this.$t('com.file.voting-settings.8-sec') },
                { id: 9, type: this.$t('com.file.voting-settings.9-sec') },
                { id: 10, type: this.$t('com.file.voting-settings.10-sec') },
            ],
            isValidIp: false,
            internalVotingSettings: {},
            internalVotingAllowedIp: ""
        }
    },
    watch: {
        'internalVotingSettings.allowIpAddress': {
            immediate: true,
            handler(val) {
                if (val === "" || val === undefined || val == null) {
                    this.isValidIp = true;
                }
                else {
                    this.isValidIp = validateIp(val);
                }
            }
        },
        votingSettings: {
            immediate: true,
            handler: function (val) {
                this.internalVotingSettings = {...val}
            }
        },
        votingAllowedIp: {
            immediate: true,
            handler: function (val) {
                this.internalVotingAllowedIp = val
            }
        }
    },
}
</script>
<style lang="scss">
@use "@/assets/scss/user-profile-component.scss";

.in-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
}

.in-row .esesja-modal__row {
    margin-bottom: 0px;
    margin-right: 10px;
}

.esesja-modal__wraper__body__label {
    cursor: pointer;
}

.settings {
    padding: 15px 10px;
}
</style>